import { engineComponent } from "neo-common";
import { Style } from "./Style";
import { ContainerElement } from "../Graphics/ContainerElement";
import { ComponentTypes } from "../../ComponentTypes";

/**
 * SwitchStyle create container from child <elements> and holds xml nodes of cases for this switch elements.
 * Example:
 *   <SwitchStyle Class="SwitchStyle">
 *      <Elements>
 *           <Child1 />
 *           <Child2 X="0" />
 *           ...
 *      </Elements>
 *      <Cases>
 *          <Case Case="CASE1">
 *              <Child2 X="50" />
 *          </Case>
 *          <Case Case="CASE2">
 *              <Child1 X="200" />
 *          </Case>
 *      </Cases>
 *   </SwitchStyle>
 * @class SwitchStyle
 * @extends Style
 */
@engineComponent(ComponentTypes.Style)
export class SwitchStyle extends Style {
    // container for childs of switch element
    container: ContainerElement;

    // xml nodes added to object by case name
    cases: Object;

    constructor() {
        super();

        this.cases = {};
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return  void
     */
    create(node: Element): void {
        super.create(node);

        let next: Element = node.firstElementChild;
        while (next != null) {
            switch (next.nodeName) {
                case "Elements":
                    this.container = new ContainerElement();
                    this.container.create(next);
                    break;
                case "Cases":
                    let nextCase: Element = next.firstElementChild;
                    while (nextCase != null) {
                        if (nextCase.hasAttribute(SwitchStyleCaseAttributes.CASE)) {
                            if (this.cases[nextCase.getAttribute(SwitchStyleCaseAttributes.CASE)] !== null) {
                                this.cases[nextCase.getAttribute(SwitchStyleCaseAttributes.CASE)] = nextCase;
                            } else {
                                if (DEBUG) {
                                    this.log(
                                        "ERROR case " +
                                            nextCase.getAttribute("Case") +
                                            " already exist in switchStyle " +
                                            node.nodeName,
                                    );
                                }
                            }
                        }
                        nextCase = nextCase.nextElementSibling;
                    }
                    break;
            }
            next = next.nextElementSibling;
        }
    }
}

const SwitchStyleAttributes = {};

export const SwitchStyleCaseAttributes = {
    CASE: "Case",
    HANDLER: "Handler",
    NEXT_CASE: "NextCase",
    TIMER: "Timer",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Styles/SwitchStyle.ts
 **/